import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../network/firebaseConfig";
import { Loading } from "../components/common/Loading";
import dayjs from "dayjs";

const ComplaintStatus = () => {
    const { id } = useParams();
    const [complaint, setComplaint] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchComplaint = async () => {
            try {
                const docRef = doc(db, "complaints", id);
                const snap = await getDoc(docRef);

                if (snap.exists()) {
                    setComplaint(snap.data());
                } else {
                    setError("Complaint not found!");
                }
            } catch (err) {
                console.error(err);
                setError("Failed to load complaint data.");
            } finally {
                setLoading(false);
            }
        };

        fetchComplaint();
    }, [id]);

    if (loading) return <Loading />;
    if (error) return <div className="p-6 text-center text-red-600">{error}</div>;

    const { customerInfo, status, ticketNumber, department, createdAt, approximateResolveTime, description, activityLogs } =
        complaint || {};

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
            <div className="max-w-2xl w-full bg-white rounded-lg shadow-md p-6">
                <h1 className="text-2xl font-bold text-center text-pink-600 mb-6">
                    Complaint Status
                </h1>

                <div className="space-y-3 text-gray-700">
                    <p><strong>Ticket:</strong> {ticketNumber}</p>
                    <p><strong>Customer:</strong> {customerInfo?.name}</p>
                    <p><strong>Phone:</strong> {customerInfo?.phone}</p>
                    <p><strong>Address:</strong> {customerInfo?.address}</p>
                    <p><strong>Department:</strong> {department}</p>
                    <p><strong>Status:</strong>
                        <span className={`ml-2 px-2 py-1 rounded text-white ${status === "pending" ? "bg-yellow-500" :
                            status === "in-progress" ? "bg-blue-500" :
                                "bg-green-600"
                            }`}>
                            {status}
                        </span>
                    </p>
                    <p><strong>Created:</strong> {dayjs(createdAt?.toDate?.()).format("DD MMM YYYY, h:mm A")}</p>
                    <p><strong>Approx. Resolve Time:</strong> {approximateResolveTime}</p>
                    <p><strong>Description:</strong> {description}</p>
                </div>

                {activityLogs?.length > 0 && (
                    <div className="mt-6 border-t pt-4">
                        <h2 className="text-lg font-semibold mb-2">Activity Logs</h2>
                        <ul className="space-y-2">
                            {activityLogs.map((log, index) => (
                                <li key={index} className="text-sm text-gray-600 border-b pb-1">
                                    <span className="block font-medium text-gray-800">
                                        {log.message}
                                    </span>
                                    <span className="text-xs text-gray-500">
                                        {dayjs(log.time?.toDate?.()).format("DD MMM YYYY, h:mm A")}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="mt-8 text-center">
                    <p className="text-sm text-gray-500">
                        — Bijoy IT Support
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ComplaintStatus;
